import { Occupancy } from './occupancy';
import { DateHelper } from '../utils/date-helper';
import { IDisplayItem } from 'src/app/modules/room-reservation/components/room-allocation-table/room-allocation-table.component';
import { Constants } from './constants.model';
import { RoomScheduleComponent } from 'src/app/modules/room-reservation/components/room-schedule/room-schedule.component';
import { Observable } from 'rxjs';

export class AvailableDevice {

    Device: string;

    DeviceId: number;

    Occupancies: Occupancy[];

    IsAvailable: boolean;

    ReservationRight: string;

    ReservationRightId: number;

    Status: string;

    StatusDate: Date;

    StatusId: number;

    StatusAllowOccupation: boolean;

    IsWorkingDay: boolean;

    // internal props
    warning: string;
    // meta info about available resource
    meta: {
        isRessourceAvailable: boolean;
        isBookingAllowed: boolean;
        actionLabel: string;
    }

    /**
     * Map untyped representation into new typed instance
     *
     * @static
     * @param {*} object
     * @returns {AvailableDevice}
     * @memberof AvailableDevice
     */
    public static create(object: AvailableDevice): AvailableDevice {
        const instance = new AvailableDevice();
        instance.Device = object.Device;
        instance.DeviceId = object.DeviceId;
        instance.Occupancies = object.Occupancies ? object.Occupancies.map(o => Occupancy.create(o)) : [];
        instance.IsAvailable = object.IsAvailable;
        instance.ReservationRight = object.ReservationRight;
        instance.ReservationRightId = object.ReservationRightId;
        instance.Status = object.Status;
        instance.StatusDate = object.StatusDate ? DateHelper.parseDateString(object.StatusDate) : null;
        instance.StatusId = object.StatusId;
        instance.IsWorkingDay = object.IsWorkingDay;
        instance.StatusAllowOccupation = object.StatusAllowOccupation;
        return instance;
    }

    /**
     * Map AvailableDevice to IDisplayItem
     *
     * @static
     * @param {AvailableDevice} ad
     * @param {Observable<string>} text
     * @returns {IDisplayItem}
     * @memberof AvailableDevice
     */
    public static mapDisplayItem(ad: AvailableDevice, text: Observable<string>, minDate: Date, maxDate: Date): IDisplayItem {
        const item: IDisplayItem = {
            resourceId: ad.DeviceId,
            designation: ad.Device,
            warning: ad.warning,
            isBookable: ad.StatusAllowOccupation
                && ad.IsAvailable && ad.IsWorkingDay
                && ad.ReservationRightId !== Constants.ReservationsRecht.Visible,
            scheduleItems: [],
            additionalColumsData: [],

            // metadata
            isRessourceAvailable: ad.meta.isRessourceAvailable, // bookable with the necessary rights
            isBookingAllowed: ad.meta.isBookingAllowed, // user posseses the necessary rights
            actionLabel: ad.meta.actionLabel // text on reserve button 
        };

        ad.Occupancies.map(o => RoomScheduleComponent.createScheduleItems(o, text, minDate, maxDate))
            .forEach(x => x.forEach(y => item.scheduleItems.push(y)));

        return item;
    }
}
